import * as React from 'react'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline'
  size?: 'sm' | 'md' | 'lg'
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', ...props }, ref) => {
    const base =
      'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-black disabled:opacity-50 disabled:pointer-events-none'

    const variantClasses =
      variant === 'primary'
        ? 'bg-[#D4AF37] text-black hover:bg-[#FFD700]'
        : variant === 'secondary'
        ? 'bg-neutral-100 text-neutral-900 hover:bg-neutral-200'
        : 'border border-neutral-300 text-neutral-900 hover:bg-neutral-50'

    const sizeClasses =
      size === 'sm'
        ? 'px-3 py-1.5 text-xs'
        : size === 'lg'
        ? 'px-6 py-3 text-base'
        : 'px-4 py-2 text-sm'

    return (
      <button
        ref={ref}
        className={`${base} ${variantClasses} ${sizeClasses} ${className ?? ''}`}
        {...props}
      />
    )
  }
)

Button.displayName = 'Button'

